import { Component } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { GlossScrollDirective } from "@bitwarden/web-vault/app/components/gloss-scroll/gloss-scroll.directive";

@Component({
  selector: "app-vault-deduplication-help-dialog",
  standalone: true,
  imports: [GlossScrollDirective, MatDialogModule, MatButtonModule],
  templateUrl: "./vault-deduplication-help-dialog.component.html",
})
export class VaultDeduplicationHelpDialogComponent {}
